<template>
  <div class="path-map">
    <div ref="mapContainer" class="l-map"></div>

    <!-- 控制按鈕（用普通 DOM + 絕對定位，不用 LControl） -->
    <div class="map-mode common">
      <button
          v-if="!hideScaleBtn"
          class="control-top-left"
          @click="mapScaleToggle"
      >
        ✕
      </button>
    </div>
    <div class="map-mode view" v-if="!isAdvancedEditMode">
<!--      <b-button-->
<!--          v-if="hideScaleBtn"-->
<!--          class="map-control"-->
<!--          @click="mapScaleToggle"-->
<!--      >-->
<!--        <img :src="mapBtnSvg" alt="map scale">-->
<!--      </b-button>-->

<!--      <b-button-->
<!--          v-if="!hideSwapBtn"-->
<!--          class="map-control"-->
<!--          @click="mapRouteReverse"-->
<!--      >-->
<!--        <img :src="imageSrc.svgRouteReverse" alt="route reverse">-->
<!--      </b-button>-->

      <b-button
          class="map-control"
          @click="toggleStrokeMethod"
      >
        <img :src="mapColorBtbSvg" alt="地圖切換鍵">
      </b-button>
    </div>
<!--    <div class="map-mode advance-edit" v-if="isAdvancedEditMode">-->
<!--      <button class="btn btn-confirm" @click="confirmAdvancedEdit">-->
<!--        編輯完成-->
<!--      </button>-->
<!--    </div>-->
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import 'leaflet.polyline.snakeanim';
import {mapGetters} from "vuex";

import MapEnlargeSVG from '@/assets/images/svgs/common/map-enlarge.svg';
import MapReduceSVG from '@/assets/images/svgs/common/map-reduce.svg';
import MilestoneSVG from '@/assets/images/icon/Milestone.svg';
import RedMilestoneSVG from '@/assets/images/icon/RedMilestone.svg';
import MilestoneLightYellowSVG from '@/assets/images/icon/Milestone-Light-Yellow.svg';
import svgDirectionsWalk from "@/assets/images/milestone-icon/directions_walk.svg";
import svgRest from "@/assets/images/milestone-icon/new-rest.svg";
import svgDistance from "@/assets/images/milestone-icon/distance.svg";
import svgClimbUp from "@/assets/images/milestone-icon/climb-up.svg";
import svgClimbDown from "@/assets/images/milestone-icon/climb-down.svg";
import svgMountains from "@/assets/images/milestone-icon/mountains.svg";
import svgParking from "@/assets/images/milestone-icon/parking.svg";
import svgHouse from "@/assets/images/milestone-icon/house.svg";
import svgToilet from "@/assets/images/milestone-icon/toilet.svg";
import svgCamp from "@/assets/images/milestone-icon/camp.svg";
import svgWalk from "@/assets/images/milestone-icon/walk.svg";
import svgWater from "@/assets/images/milestone-icon/water.svg";
import svgWifi from "@/assets/images/milestone-icon/wifi.svg";
import svgRouteReverse from "@/assets/images/icon/route_reverse.svg";
import PenSVG from '@/assets/images/svgs/common/pen.svg';
import PenOffSVG from '@/assets/images/svgs/common/pen-off.svg';

export default {
  name: 'PathMapPro',
  props: {
    mapScaleMaximum: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideScaleBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideSwapBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      mapReady: false,

      map: null,
      completedRouteLayer: null,
      pendingRouteLayer: null,
      linkedRouteLayer: null,
      startIcon: null,
      endIcon: null,
      milestoneIcon: null,
      linkedSnakeTimer: null,
      linkedSnakeRunning: false,


      // 地圖上的所有可視點
      candidateMilestones: [],

      // render 用
      milestoneMarkers: [],
      selectingMilestoneSerial: -1,

      // 進階編輯的當下位置
      currentMilestoneMarker: null,

      queriedBounds: null,

      drawDifficulty: true,

      imageSrc: {
        svgDirectionsWalk: svgDirectionsWalk,
        svgRest: svgRest,
        svgDistance: svgDistance,
        svgClimbUp: svgClimbUp,
        svgClimbDown: svgClimbDown,

        svgMountains: svgMountains,
        svgParking: svgParking,
        svgHouse: svgHouse,
        svgToilet: svgToilet,
        svgCamp: svgCamp,
        svgWalk: svgWalk,
        svgWater: svgWater,
        svgWifi: svgWifi,

        svgRouteReverse: svgRouteReverse,
        svgPen: PenSVG,
        svgPenOff: PenOffSVG,
      },
    };
  },
  components: {
  },
  computed: {
    ...mapGetters('journey', ['journeyData', 'journeyObjectArray', 'compiledSplitIndexs', 'compiledJourneyArray', 'journeyParts', 'isComplete', 'linkedRoutes']),

    mapColorBtbSvg() {
      return this.drawDifficulty ? this.imageSrc.svgPen: this.imageSrc.svgPenOff;
    },
    isAdvancedEditMode() {
      return !this.isComplete;
    },
    currentMilestoneIcon() {
      return this.isAdvancedEditMode
          ? L.icon({
            iconUrl: MilestoneSVG,
            iconSize: [32, 32],
            iconAnchor: [16, 24],
          })
          : this.milestoneIcon;
    },
    RedMilestoneIcon() {
      return L.icon({
        iconUrl: RedMilestoneSVG,
        iconSize: [32, 32],
        iconAnchor: [16, 24],
      });
    },
    routeLineWeight() {
      return this.isAdvancedEditMode ? 6 : 3;
    },
    analyzedJourneyParts() {
      if (!Array.isArray(this.journeyParts) || this.journeyParts.length === 0) {
        return {
          completed: null,
          incompleted: [],
        };
      }

      // 👉 只有一段，必然是完整路線
      if (this.journeyParts.length === 1) {
        const part = this.journeyParts[0];
        const splitResult = this.splitByType(part)

        // 計算 difficulties（只針對 completed 部分）
        const difficulties = this._calcCompletedDifficulties(splitResult)

        return {
          completed: {
            ...splitResult,
            difficulties
          },
          incompleted: [],
        };
      }

      // // 👉 多段時
      const completedPart = this.journeyParts[0];
      const incompletedParts = this.journeyParts.slice(1);

      return {
        completed: this.splitByType(completedPart),
        incompleted: incompletedParts.map(p => this.splitByType(p)),
      };
    },
    completedRoutePolylines() {
      const routes = this.analyzedJourneyParts?.completed?.routes || [];

      return routes
          .map(route => {
            const pts = route.detail?.routepts;
            if (!Array.isArray(pts) || pts.length < 2) return null;

            return pts.map(p => [p.lat, p.lng]);
          })
          .filter(Boolean);
    },
    incompletedRoutePolylines() {
      const routeGroups = this.analyzedJourneyParts?.incompleted || [];

      return routeGroups
          .map(part => part.routes || [])
          .flat() // ⭐ 多段未完成路線 → 攤平成一層
          .map(route => {
            const pts = route.detail?.routepts;
            if (!Array.isArray(pts) || pts.length < 2) return null;

            return pts.map(p => [p.lat, p.lng]);
          })
          .filter(Boolean);
    },
    mapBtnSvg() {
      return this.mapScaleMaximum ? MapReduceSVG : MapEnlargeSVG;
    },
    availableCandidateMilestones() {
      if (!this.isAdvancedEditMode) return [];

      const draftSerials = new Set(
          this.journeyObjectArray.filter(
              item => item.type === 'milestone').map(m => m.serial)
      );

      return this.candidateMilestones.filter(
          candidate => !draftSerials.has(candidate.serial)
      );
    },
  },
  watch: {
    selectingMilestoneSerial(val) {
      this.milestoneMarkers.forEach((m) => {
        if (m.__serial === val) m.openPopup();
      });
    },
    journeyParts() {
      this.renderAll();
    },
    linkedRoutes() {
      this.drawLinkedRoutes();
    },
  },
  created() {
    this.$nextTick(async () => {
      this.map.invalidateSize();

      this.renderAll();

      // 綁定 moveend 事件
      this.map.on("moveend", this.handleMapBoundsChanged);
    });
  },
  async mounted() {
    this.initMap();
    this.$nextTick(() => {
      setTimeout(() => {
        this.fitToCurrentMilestones();
      }, 1000);
    });
  },
  beforeDestroy() {
    if (this.linkedSnakeTimer) {
      clearTimeout(this.linkedSnakeTimer);
    }
    this.linkedSnakeRunning = false;

    if (this.map) {
      this.map.off("moveend", this.handleMapBoundsChanged);
      this.map.remove(); // 徹底銷毀 Leaflet 實例
    }
  },
  methods: {
    initMap() {
      this.map = L.map(this.$refs.mapContainer, {
        zoomControl: false,
        // 先給一個預設中心，絕對不能讓 Leaflet 處於無中心狀態
        center: [23.973875, 120.982024],
        zoom: 8,
      });

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 19,
      }).addTo(this.map);

      // pending 在下面
      this.map.createPane('pendingRoutes');
      this.map.getPane('pendingRoutes').style.zIndex = 400;

      // completed 在上面
      this.map.createPane('completedRoutes');
      this.map.getPane('completedRoutes').style.zIndex = 500;

      // linked 最上層
      this.map.createPane('linkedRoutes');
      this.map.getPane('linkedRoutes').style.zIndex = 600;

      // 進階編輯的當下位置
      this.map.createPane('currentMilestone');
      this.map.getPane('currentMilestone').style.zIndex = 700;

      // 等 Vue DOM 更新完再校正大小
      this.$nextTick(() => {
        this.map.invalidateSize(true);  // true 表示強制重算

        // 再次保險：如果因為容器還沒準備好而 center 丟失，就再設一次
        if (!this.map.getCenter()) {
          this.map.setView([23.973875, 120.982024], 8);
        }

        this.mapReady = true;
      });

      this.map.on("click", this.mapClicked);

      this.startIcon = L.icon({
        iconUrl: "https://maps.google.com/mapfiles/kml/paddle/go.png",
        iconSize: [32, 32],
        iconAnchor: [16, 32],
      });
      this.endIcon = L.icon({
        iconUrl: "https://maps.google.com/mapfiles/kml/paddle/grn-square.png",
        iconSize: [32, 32],
        iconAnchor: [16, 32],
      });
      this.milestoneIcon = L.icon({
        iconUrl: "https://maps.google.com/mapfiles/kml/paddle/grn-blank.png",
        iconSize: [32, 32],
        iconAnchor: [16, 32],
      });

      this.fitToCurrentMilestones();
    },

    renderAll() {
      // 整體重繪
      if (!this.map) return;
      this.clearMapObjects();

      this.drawMilestones();
      this.drawRoutes();

      // 進階編輯模式
      if (this.isAdvancedEditMode) {
        this.drawPendingRoutes();
        this.drawCandidateMilestones();
        this.drawLinkedRoutes();
        this.drawCurrentMilestone();
      }
    },

    clearMapObjects() {
      if (this.completedRouteLayer) {
        this.completedRouteLayer.clearLayers(); // 清掉裡面的 polyline
        this.map.removeLayer(this.completedRouteLayer); // 從地圖移除 layerGroup
        this.completedRouteLayer = null;
      }

      if (this.pendingRouteLayer) {
        this.pendingRouteLayer.clearLayers();
        this.map.removeLayer(this.pendingRouteLayer);
        this.pendingRouteLayer = null;
      }

      if(this.linkedRouteLayer) {
        this.linkedRouteLayer.clearLayers();
        this.map.removeLayer(this.linkedRouteLayer);
        this.linkedRouteLayer = null;
      }

      if(this.currentMilestoneMarker) {
        this.map.removeLayer(this.currentMilestoneMarker);
        this.currentMilestoneMarker = null;
      }

      this.milestoneMarkers.forEach((m) => m.remove());
      this.milestoneMarkers = [];
    },

    drawMilestones() {
      this.analyzedJourneyParts.completed.milestones.forEach((m) => {
        const milestoneData = m.detail
        const marker = L.marker([milestoneData.lat, milestoneData.lng], {
          icon: this.currentMilestoneIcon,
          draggable: false,
        })
            .addTo(this.map)
            .bindPopup(`<div class="text-center">${milestoneData.name}<br/>${milestoneData.height} m</div>`)
            .on("click", () => this.milestoneMarkerClicked(milestoneData.serial));

        marker.__serial = milestoneData.serial;
        this.milestoneMarkers.push(marker);
      });
      if(this.isAdvancedEditMode) {
        const incompletedMilestonesGroups = this.analyzedJourneyParts?.incompleted || []
        incompletedMilestonesGroups.map(part => part.milestones || []).flat().forEach((m) => {
          const milestoneData = m.detail
          const marker = L.marker([milestoneData.lat, milestoneData.lng], {
            icon: this.currentMilestoneIcon,
            draggable: false,
          })
              .addTo(this.map)
              .bindPopup(`<div class="text-center">${milestoneData.name}<br/>${milestoneData.height} m</div>`)
              .on("click", () => this.milestoneMarkerClicked(milestoneData.serial));

          marker.__serial = milestoneData.serial;
          this.milestoneMarkers.push(marker);
        });
      }
    },

    drawRoutes() {
      if (!this.map) return;

      // 確保 completedRouteLayer 存在
      if (!this.completedRouteLayer) {
        this.completedRouteLayer = L.layerGroup([], {
          pane: 'completedRoutes',
        }).addTo(this.map);
      } else {
        this.completedRouteLayer.clearLayers();
      }

      // 取得目前要繪製的路線點陣列
      const polylines = this.completedRoutePolylines || [];

      // 取得 analyzedJourneyParts 的 completed.difficulties（只在非編輯模式使用）
      const difficulties = this.isAdvancedEditMode
          ? null
          : this.analyzedJourneyParts?.completed?.difficulties || [];

      polylines.forEach((latlngs, index) => {
        // 預設樣式（進階編輯模式用）
        let color = 'blue';
        let weight = this.routeLineWeight;

        // 非編輯模式時，根據 difficulty 動態調整
        if (!this.isAdvancedEditMode && this.drawDifficulty) {
          const diffItem = difficulties[index];
          if (diffItem && typeof diffItem.difficulty === 'number') {
            const diffValue = diffItem.difficulty;

            if (diffValue >= 265) {
              // rank 3：紅色、粗線
              color = 'red';
              weight = 6;
            } else if (diffValue >= 175) {
              // rank 2：黃色、正常粗細
              color = 'yellow';
              weight = 3;  // 你可以改成 this.routeLineWeight 或其他值
            } else {
              // rank 1：藍色、正常粗細
              color = 'blue';
              weight = 3;  // 同上
            }
          }
          // 如果該 index 沒有對應的 difficulty，保持預設藍色
        }

        // 建立 polyline 並加入 layer
        L.polyline(latlngs, {
          color,
          weight,
          opacity: 1,
          pane: 'completedRoutes',
        }).addTo(this.completedRouteLayer);
      });
    },

    drawPendingRoutes() {
      if (!this.map) return;

      if (!this.pendingRouteLayer) {
        this.pendingRouteLayer = L.layerGroup([], {
          pane: 'pendingRoutes',
        }).addTo(this.map);
      } else {
        this.pendingRouteLayer.clearLayers();
      }

      this.incompletedRoutePolylines.forEach(latlngs => {
        L.polyline(latlngs, {
          color: 'gray',
          weight: this.routeLineWeight,
          opacity: 0.5,
          pane: 'pendingRoutes',
        }).addTo(this.pendingRouteLayer);
      });
    },

    drawLinkedRoutes() {
      if (!this.map) return;

      this.linkedSnakeRunning = false;

      if (this.linkedSnakeTimer) {
        clearTimeout(this.linkedSnakeTimer);
        this.linkedSnakeTimer = null;
      }

      if (this.linkedRouteLayer) {
        this.map.removeLayer(this.linkedRouteLayer);
      }

      this.linkedRouteLayer = L.layerGroup([], {
        pane: 'linkedRoutes',
      }).addTo(this.map);

      const linkedRoutes = this.linkedRoutes || [];
      if (linkedRoutes.length === 0) return;

      // 建立所有 polyline
      const polylines = linkedRoutes
          .map(route => {
            const lastMilestoneSerial =
                this.analyzedJourneyParts?.completed?.milestones?.[
                this.analyzedJourneyParts.completed.milestones.length - 1
                    ]?.serial;

            const rawPts = route.routepts || [];

            if (!Array.isArray(rawPts) || rawPts.length < 2) return null;

            let pts = rawPts;

            // 順向：startMilestone === 最後一個 milestone → 不動
            if (route.startMilestone === lastMilestoneSerial) {
              pts = rawPts;
            }
            // 逆向：endMilestone === 最後一個 milestone → 反轉
            else if (route.endMilestone === lastMilestoneSerial) {
              pts = [...rawPts].reverse(); // ⭐ 一定要 clone 再 reverse
            }

            // 轉 leaflet 格式
            const latlngs = pts.map(pt => [pt.lat, pt.lng]);

            const line = L.polyline(latlngs, {
              color: '#A51814',
              weight: this.routeLineWeight / 2,
              dashArray: '8, 8',
              pane: 'linkedRoutes',
            }).addTo(this.linkedRouteLayer);

            line.__latlngs = latlngs;
            return line;
          })
          .filter(Boolean);

      if (polylines.length === 0) return;

      // loop 控制器
      const startLoop = () => {
        if (!this.linkedSnakeRunning) return;

        let finishedCount = 0;
        const total = polylines.length;

        polylines.forEach(line => {
          if (!line.snakeIn) return;

          // reset 狀態（超關鍵）
          line._snaking = false;
          line._snakeLatLngs = null;

          line.setLatLngs([]);
          line.setLatLngs(line.__latlngs);

          // 同時開始
          line.snakeIn();

          line.once('snakeend', () => {
            finishedCount++;

            // 全部完成才進下一輪
            if (finishedCount === total) {
              this.linkedSnakeTimer = setTimeout(() => {
                startLoop();
              }, 500);
            }
          });
        });
      };

      // 啟動
      this.linkedSnakeRunning = true;
      startLoop();
    },

    drawCurrentMilestone() {
      if (!this.map) return;

      // 先清掉舊的（避免殘留）
      if (this.currentMilestoneMarker) {
        this.map.removeLayer(this.currentMilestoneMarker);
        this.currentMilestoneMarker = null;
      }

      const currentMilestone =
          this.analyzedJourneyParts?.completed?.milestones?.[
          this.analyzedJourneyParts.completed.milestones.length - 1
              ];

      if (!currentMilestone || !currentMilestone.detail) return;

      const { lat, lng, name } = currentMilestone.detail;

      // 建立 marker
      const marker = L.marker([lat, lng], {
        icon: this.RedMilestoneIcon,
        pane: 'currentMilestone', // zIndex 700
      })
          .addTo(this.map)
          .bindPopup(`<div class="text-center">${name}</div>`);

      // 點擊打開 popup
      marker.on('click', () => {
        marker.openPopup();
      });

      // 存起來（之後清除用）
      this.currentMilestoneMarker = marker;
    },

    /** 根據目前 active 的 milestones 調整地圖視圖（不觸發 API） */
    fitToCurrentMilestones() {
      if (!this.map || !this.mapReady) return;

      const points = this.journeyObjectArray.filter(
          item => item.type === 'milestone');
      if (!points || points.length === 0) {
        this.map.setView([23.973875, 120.982024], 8);
        return;
      }

      const bounds = L.latLngBounds();
      points.forEach(p => bounds.extend([p.detailObject.lat, p.detailObject.lng]));

      if (bounds.isValid()) {
        this.map.fitBounds(bounds, {
          padding: [10, 10],
          animate: true,
        });
      }
    },

    async handleMapBoundsChanged() {
      const currentBounds = this.map.getBounds();
      if (!currentBounds || !currentBounds.isValid()) return;

      if (!this.queriedBounds) {
        // 異常情況，應該在 fitMilestoneBoundsAndFetchData 中初始化
        this.queriedBounds = L.latLngBounds(
            currentBounds.getSouthWest(),
            currentBounds.getNorthEast()
        );
        await this.fetchDataWithinBounds(currentBounds);
        return;
      }

      // 檢查當前範圍是否完全包含在已查詢範圍內
      // Leaflet 的 contains 方法:
      // 如果 currentBounds 的四個角都在 queriedBounds 內，則視為已包含，不打 API。
      if (this.queriedBounds.contains(currentBounds)) {
        console.log("當前範圍已包含在已查詢範圍內，不重複查詢。");
        return;
      }

      console.log("檢測到新區域，進行 API 查詢並擴大已查詢範圍。");
      await this.fetchDataWithinBounds(currentBounds);

      // 擴大已查詢範圍
      this.queriedBounds.extend(currentBounds);
    },

    async fetchDataWithinBounds(bounds) {
      try {
        const response = await this.$store.dispatch("api/postPathQuerySquareAreaDataPromise", {
          latMin: bounds.getSouth(),
          latMax: bounds.getNorth(),
          lngMin: bounds.getWest(),
          lngMax: bounds.getEast(),
        });
        console.log("API 回傳資料:", response);

        this.candidateMilestones = response;
        console.log("載入候選點:", this.candidateMilestones.length, "個");

        this.$nextTick(() => {
          this.renderAll();
        });
      } catch (error) {
        console.error("載入可視範圍資料失敗", error);
        this.candidateMilestones = [];

        this.$nextTick(() => {
          this.renderAll();
        });
      }
    },

    mapClicked(evt) {
      console.log("Map clicked:", evt.latlng);
    },

    milestoneMarkerClicked(serial) {
      this.selectingMilestoneSerial = serial;
    },

    mapScaleToggle() {
      this.$emit("toggle-map-scale");
    },

    mapRouteReverse() {
      this.$emit("reverse-map-route");
    },

    /** 繪製候選里程碑（淡色或不同圖示） */
    drawCandidateMilestones() {
      const candidates = this.availableCandidateMilestones;

      candidates.forEach((m) => {
        const marker = L.marker([m.lat, m.lng], {
          // 正確做法：現場建立 L.icon 實例
          icon: L.icon({
            iconUrl: MilestoneLightYellowSVG,
            iconSize: [32, 32],
            iconAnchor: [16, 24],
          }),
        })
            .addTo(this.map)
            .bindPopup(`<div class="text-center">${m.name}<br/>${m.height} m</div>`)
            .on("click", () => this.milestoneMarkerClicked(m.serial));

        marker.__serial = m.serial;
        marker.__isCandidate = true;
        this.milestoneMarkers.push(marker);
      });
    },

    splitByType(part) {
      const milestones = [];
      const routes = [];

      part.forEach(item => {
        if (item.type === 'milestone') {
          milestones.push(item);
        } else if (item.type === 'route') {
          routes.push(item);
        }
      });

      return {
        raw: part,          // 保留原順序（畫線、動畫用）
        milestones,         // 畫點用
        routes,             // 畫線用
      };
    },

    _calcCompletedDifficulties(splitResult) {
      const { milestones = [], routes = [] } = splitResult || {}

      // 至少要有 2 個里程碑 + 1 段路線才算得出難易度
      if (milestones.length < 2 || routes.length === 0) {
        return []
      }

      const difficulties = []

      // 假設 routes 順序與 milestones 對應（milestones[0] → routes[0] → milestones[1]）
      for (let i = 0; i < routes.length; i++) {
        const route = routes[i]
        const startMs = milestones[i]
        const endMs = milestones[i + 1]

        if (!startMs || !endMs) continue

        // 高低差（絕對值）
        const milestoneHeightDis = Math.abs(
            endMs.detail.height - startMs.detail.height
        )

        // 距離（轉公里）
        const distance = (route.detail.distance || 0) / 1000

        // 難易度：高低差 / 距離（公里）
        const difficulty = distance > 0 ? milestoneHeightDis / distance : 0

        // 路線點 pts（依你原本邏輯，如果 route 有 pts 就用，否則可自行組合）
        let pts = route.detail.pts || []

        // 如果 route 沒有 pts 欄位，你可以這樣手動組合（視需求開啟）
        // if (pts.length === 0) {
        //   pts = [
        //     { lat: startMs.detail.lat, lng: startMs.detail.lng },
        //     ...(route.detail.routepts || []),
        //     { lat: endMs.detail.lat, lng: endMs.detail.lng }
        //   ]
        // }

        difficulties.push({
          pts,
          difficulty: Number(difficulty.toFixed(2)),       // 保留兩位小數
          milestoneHeightDis: Number(milestoneHeightDis.toFixed(1)) // 可調整小數位
        })
      }

      return difficulties
    },

    toggleStrokeMethod() {
      this.drawDifficulty = !this.drawDifficulty;
      this.renderAll();
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/basic";
  .path-map {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 0;
    .l-map {
      height: 100%;
    }
  }

  .l-map {
    width: 100%;
    height: 100%;
  }

  .m-list {
    margin-left: -10px;
    margin-bottom: -10px;
    padding: 15px 15px 24px;
    background-color: #fff6;
  }

  .f-main {

  }

  .f-cell {
    padding: 5px;
  }

  .flickity-container {
    width: 100%;
    padding: .5rem .5rem 1rem;
    background-color: #fff6;
    margin: 0 !important;
    margin-bottom: -1rem !important;
  }

  .milestone-list {
    width: 100%;
    margin: 0 !important;
  }

  ::v-deep {
    .leaflet-bottom.leaflet-right {
      left: 0;
      right: 0;
      padding: 0;
    }
  }

  .outside-nav {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 15px 15px 24px;
    background-color: #fff6;
    z-index: 400;
  }

  .nav-btn {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    font-size: 1rem;
    line-height: 1.5;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    font-size: .875rem;
    border-radius: 1.25rem;
    padding: 0.5rem 1.25rem;
    background-color: #eee;
    color: #333;
    border: none;
  }

  .nav-btn:hover {

  }

  .nav-btn:active {

  }

  .nav-btn:focus {

  }

  .is-selected .nav-btn {
    background-color: #666;
    color: #fff;
  }

  .btn.control-btn {
    background: $color-white;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    img {
      width: 28px;
      height: 28px;
      object-fit: cover;
    }
  }
  .btn.btn-map-close {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    border-radius: 100px;
    color: $color-white;
    background: $color-black-800;
    padding: 0;
  }
  .btn.btn-reverse {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: $color-black;
    background: $color-white;
    padding: 0;
  }

  .map-mode {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 400;
    padding: 0 .5rem 1.5rem 0;
    &.view {
      display: flex;
      flex-direction: column;
      gap: .5rem;
    }
    .btn.map-control {
      background: $color-white;
      width: 56px;
      height: 56px;
      border-radius: 50%;
      img {
        width: 28px;
        height: 28px;
        object-fit: cover;
      }
    }
  }
</style>
